import { apiClient } from './client';
import type { EarlyAccessItem, EarlyAccessItemPayload } from './earlyAccess.types';

export function listEnrollments (params: Record<string, unknown>) {
  return apiClient.get('/early-access/list', { params });
}

export function exportEnrollments (search?: string) {
  return apiClient.get('/early-access/export', { params: { search } });
}

export function updateNotes (shopId: number | string, notes: string) {
  return apiClient.put(`/${shopId}/early-access/notes`, { notes });
}

export function listItems () {
  return apiClient.get<{ items: EarlyAccessItem[] }>('/early-access/items');
}

/** No single-item internal endpoint exists, so resolve from the list. */
export async function getItem (id: number | string): Promise<EarlyAccessItem | null> {
  const { data } = await listItems();
  return (data.items ?? []).find((item) => String(item.id) === String(id)) ?? null;
}

export function createItem (payload: EarlyAccessItemPayload) {
  return apiClient.post<{ item: EarlyAccessItem }>('/early-access/items', payload);
}

export function updateItem (id: number | string, payload: EarlyAccessItemPayload) {
  return apiClient.put<{ item: EarlyAccessItem }>(`/early-access/items/${id}`, payload);
}

export function uploadThumbnail (file: File) {
  const formData = new FormData();
  formData.append('image', file);
  return apiClient.post<{ url: string }>('/early-access/items/thumbnail', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteItem (id: number | string) {
  return apiClient.delete(`/early-access/items/${id}`);
}
